<template>
	<div class="dialog-form">
		<div class="dialog-form-body">

			<el-collapse v-model="collapseState">
				<el-collapse-item title="聚合货源" name="default">
					<!-- <el-checkbox-group v-model="detail.cate_shop_ids" @change="handleCheckedChange3">
						<el-checkbox v-for="item in enums.cate_list" :label="item.id" :key="item.id">{{ item.label }}({{ item.total }})</el-checkbox>
					</el-checkbox-group> -->
					<div class="ali_cate">
						<el-cascader-panel v-model="ali_cate_ids" @change="onAliCateChange" :props="{ multiple: true }" :options="enums.al_cate_list"></el-cascader-panel>
					</div>
				</el-collapse-item>
			</el-collapse>
			<!-- <el-collapse v-model="collapseState2">
				<el-collapse-item title="线下货源" name="default">
					<el-checkbox-group v-model="detail.s_cate_shop_ids">
						
						<el-checkbox v-if="item.visible==1" v-for="item in enums.cate_list2" :label="item.id" :key="item.id">{{ item.label }}({{ item.total }})</el-checkbox>
						<el-button v-else type="text" style="color: #333;width:26%;border:0;" icon="el-icon-lock" @click="showInputProductInviteCode(item.id)">{{ item.label }}({{ item.total }})</el-button>
					</el-checkbox-group>
				</el-collapse-item>
			</el-collapse> -->
			<el-collapse v-model="collapseState3">
				<el-collapse-item title="直发货源" name="default">
					<el-checkbox-group v-model="detail.lh_cate_shop_ids">
						<el-checkbox v-for="item in enums.cate_list3" :label="item.id" :key="item.id">{{ item.label }}({{ item.total }})</el-checkbox>
					</el-checkbox-group>
				</el-collapse-item>
			</el-collapse>
			<el-form ref="form" :model="detail" label-width="100px">
				<!--				<el-form-item label="每日复制数量">-->
				<!--					<el-select v-model="detail.copy_limit_id" placeholder="请选择每日复制数量">-->
				<!--						<el-option v-for="item in enums.copy_limit" :key="item.id" :label="item.label" :value="item.id"></el-option>-->
				<!--					</el-select>-->
				<!--				</el-form-item>-->
				<el-form-item label="每日复制数量">
					<el-input v-model="detail.copy_limit" placeholder="请输入每日复制数量"></el-input>
				</el-form-item>
				<el-form-item label="发货方式">
					<el-select v-model="detail.alibaba_deliver_type" placeholder="发货方式">
						<el-option label="全部" :value="1"></el-option>
						<el-option label="直发" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="加价" class="price_box">
					<!--<el-input v-model="detail.inc_price" placeholder="请输入加价金额"></el-input>-->
					<div class="con">
						<p class="t">原价格 x</p>
						<el-input class="w80 ml8" v-model="detail.inc_price_percent"></el-input>
						<p class="t ml8">%</p>
						<el-select class="w80 ml8" v-model="detail.price_type">
							<el-option label="+" :value="1">+</el-option>
							<el-option label="-" :value="2">-</el-option>
						</el-select>
						<el-input class="w80 ml8" v-model="detail.inc_price"></el-input>
						<p class="t ml8">元</p>
					</div>
				</el-form-item>
				<el-form-item label="升级版加价" class="price_box">
					<!--<el-input v-model="detail.inc_price" placeholder="请输入加价金额"></el-input>-->
					<div class="con">
						<p class="t"><el-checkbox v-model="detail.open_inc_price_2"></el-checkbox> 原价格 x</p>
						<el-input class="w80 ml8" v-model="detail.inc_price_percent_2"></el-input>
						<p class="t ml8">%</p>
						<el-select class="w80 ml8" v-model="detail.price_type_2">
							<el-option label="+" :value="1">+</el-option>
							<el-option label="-" :value="2">-</el-option>
						</el-select>
						<el-input class="w80 ml8" v-model="detail.inc_price_2"></el-input>
						<p class="t ml8">元</p>
					</div>
				</el-form-item>
				<el-form-item label="旗舰版加价" class="price_box">
					<!--<el-input v-model="detail.inc_price" placeholder="请输入加价金额"></el-input>-->
					<div class="con">
						<p class="t"><el-checkbox v-model="detail.open_inc_price_3"></el-checkbox> 原价格 x</p>
						<el-input class="w80 ml8" v-model="detail.inc_price_percent_3"></el-input>
						<p class="t ml8">%</p>
						<el-select class="w80 ml8" v-model="detail.price_type_3">
							<el-option label="+" :value="1">+</el-option>
							<el-option label="-" :value="2">-</el-option>
						</el-select>
						<el-input class="w80 ml8" v-model="detail.inc_price_3"></el-input>
						<p class="t ml8">元</p>
					</div>
				</el-form-item>
				<el-form-item label="每个用户每次下单限购件数" class="limit_box">
					<el-input-number v-model="detail.maximum_per_order" placeholder="请输入每个用户每次下单限购件数"></el-input-number>
				</el-form-item>
				<el-form-item label="每个用户累计限购件数" class="limit_box">
					<el-input-number v-model="detail.limit_per_buyer" placeholder="请输入每个用户累计限购件数"></el-input-number>
				</el-form-item>
				<el-form-item label="每个用户每次下单至少购买的件数" class="limit_box">
					<el-input-number v-model="detail.minimum_per_order" placeholder="请输入每个用户每次下单至少购买的件数"></el-input-number>
				</el-form-item>
				
				<el-form-item label="库存类型">
					<el-radio-group v-model="detail.stock_type">
						<el-radio :label="10">同步上家库存</el-radio>
						<el-radio :label="20">默认库存N件</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="默认库存数量" v-if="detail.stock_type==20">
					<el-input v-model="detail.default_stock" placeholder="请输入默认库存数量"></el-input>
				</el-form-item>
				<el-form-item label="关联店铺">
					<el-select v-model="detail.shop_id" placeholder="请选择关联店铺" @change="detail.freight_id = null">
						<el-option v-for="item in enums.shop" :key="item.id" :label="item.label" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="发货策略">
					<el-select v-model="detail.deliver_id" placeholder="请选择发货策略">
						<el-option v-for="item in enums.deliver" :key="item.id" :label="item.label" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运费模板">
					<el-select v-model="detail.freight_template_id" placeholder="请选择运费模板" :disabled="freight_list.length == 0 || !detail.shop_id">
						<el-option v-for="item in freight_list" :key="item.id" :label="item.label" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="上架方式">
					<el-radio-group v-model="detail.puhuo_type">
						<el-radio :label="1">上架售卖</el-radio>
						<el-radio :label="2">放入仓库</el-radio>
						<el-radio :label="3">放入草稿箱</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<div class="dialog-form-body-tips">{{ TIPS }}</div>
		</div>
		<div class="dialog-form-footer">
			<el-button class="default" @click="handlerCancel">取消</el-button>
			<el-button class="primary" @click="handlerSubmit">确定</el-button>
		</div>
	</div>
</template>

<script>
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	props: {
		enums: {
			type: Object,
			default: {}
		},
	},
	data() {
		return {
			collapseState: ['default'],
			collapseState2: ['default'],
			collapseState3: ['default'],
			TIPS: '* 本站货盘将铺货到您店铺草稿箱，请您审核后再上架商品，上架后的商品出现任何违规，均与本站无关，使用本站即默认本条约!',
			freight_list: [],
			ali_cate_ids: [],
			detail: {
				shop_id: '',
				cate_shop_ids: [],
				s_cate_shop_ids: [],
				lh_cate_shop_ids: [],
				puhuo_type: 3,
				inc_price: 0,
				inc_price_percent: 100,
				price_type: 1,
				open_inc_price_2: false,
				inc_price_2: 0,
				inc_price_percent_2: 110,
				price_type_2: 1,
				open_inc_price_3: false,
				inc_price_3: 0,
				inc_price_percent_3: 120,
				price_type_3: 1,
				alibaba_deliver_type: 1,
				maximum_per_order: 3,
				limit_per_buyer: 5,
				minimum_per_order: 1,
				stock_type: 10,
				default_stock: '',
				al_cate_1: [],
				al_cate_2: [],
				al_cate_3: [],
			},
		}
	},
	watch: {
		'detail.shop_id': {
			handler(val) {
				this.syncFreightTemplate();
			}
		},
		
	},
	methods: {
		...mapActions({
			opBindProductInviteCode:"ucenter/opBindProductInviteCode",
		}),
		//绑定特邀渠道分类邀请码
		showInputProductInviteCode(cate_shop_id){
			this.$prompt('此分类为特邀渠道，请输入邀请码', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputErrorMessage: '请输入邀请码',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						const value = instance.inputValue
						this.opBindProductInviteCode({data:{cate_shop_id,product_invite_code:value},success:(res)=>{
							instance.confirmButtonLoading = false;
							if(res.code===200){
									this.bindProductInviteCodeSuccess(cate_shop_id)
									this.$message({message: res.msg,type: 'success'});
									done()
								} else {
									this.$message({message: res.msg,type: 'error'});
									return false // 阻止关闭
								}
						}})
					} else {
						done()
					}
				},
			});
		},
		bindProductInviteCodeSuccess(cate_shop_id){
			this.$emit('bindSuccess', cate_shop_id)
		},
		onAliCateChange(arr_selected) {
			// console.log(arr_selected)
			let al_cate_1 = [];
			let al_cate_2 = [];
			let al_cate_3 = [];
			for(var i in arr_selected){
				let item = arr_selected[i]
				if(item[0] && al_cate_1.indexOf(item[0])===-1){
					al_cate_1.push(item[0])
				}
				if(item[1] && al_cate_2.indexOf(item[1])===-1){
					al_cate_2.push(item[1])
				}
				if(item[2] && al_cate_3.indexOf(item[2])===-1){
					al_cate_3.push(item[2])
				}
			}
			this.detail.al_cate_1 = al_cate_1
			this.detail.al_cate_2 = al_cate_2
			this.detail.al_cate_3 = al_cate_3
			
			// console.log(this.detail)
		},
		//复显阿里巴巴分类选中值
		initAliCateSelected(){
			let al_cate_list = this.enums.al_cate_list || false
			if(al_cate_list){
				// console.log(666,al_cate_list,this.detail)
				let arr_selected = []
				al_cate_list.map((cate_1,index_1)=>{
					let cate_2_list = cate_1.children || []
					cate_2_list.map((cate_2,index_2)=>{
						let cate_3_list = cate_2.children || []
						cate_3_list.map((cate_3,index_3)=>{
							if(this.detail.al_cate_3.indexOf(cate_3.value) > -1){
								arr_selected.push([cate_1.value,cate_2.value,cate_3.value])
							}
						})
						if(cate_3_list.length==0){
							if(this.detail.al_cate_2.indexOf(cate_2.value) > -1){
								arr_selected.push([cate_1.value,cate_2.value])
							}
						}
					})
					if(cate_2_list.length==0){
						if(this.detail.al_cate_1.indexOf(cate_1.value) > -1){
							arr_selected.push([cate_1.value])
						}
					}
				})
				this.ali_cate_ids = arr_selected
			}
		},
		handlerSubmit() {
			const data = {...this.detail, status: 1};
			// console.log(333,data)
			this.$emit('confirm', data)
		},
		handlerCancel() {
			this.$emit('cancel')
		},
		handleCheckedChange3(e){
			console.log(e)
		},
		syncFreightTemplate() {
			let list = []
			for (let item of this.enums.shop) {
				if (item.shop_id == this.detail.shop_id) {
					list = item.freightTemplate;
					break;
				}
			}
			let clear = true;
			for (let item of list) {
				if (item.id == this.detail.freight_template_id) {
					clear = false;
					break;
				}
			}
			if (clear) {
				this.detail.freight_template_id = null;
			}
			this.freight_list = list;
		},
	}
}
</script>
<style scoped>
.price_box .con {
	flex: 1;
	width: 0;
	display: flex;
	align-items: center;
	width: 400px;
}

.price_box .con .t {
	font-size: 14px;
}


.ml8 {
	margin-left: 8px;
}

.w80 {
	width: 80px !important;
}
.ali_cate{
	padding-bottom: 10px;
}
/deep/.ali_cate .el-cascader-menu{
	min-width: 248px !important;
}
/deep/.ali_cate .el-checkbox{
	width: 15px !important;
}
/deep/.ali_cate .el-cascader-node{
	height: 24px;
	line-height: 24px;
}

</style>
<style lang="less" scoped>
.dialog-form {
	&-body {
		.el-collapse {
			border: unset;

			&-item {
				:deep(&__header) {
					font-size: 14px;
					font-weight: bold;
					color: #333333;
					border: unset;
				}

				:deep(&__wrap) {
					border: unset;
				}

				:deep(&__content) {
					padding: 0;

					.el-checkbox {
						width: 28%;
						display: flex;
						align-items: center;

						&__label {
							width: 100%;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;

						}

						&-group {
							display: flex;
							flex-wrap: wrap;
							row-gap: 10px;
						}
					}

				}

				:deep(&__arrow) {
					transform: rotate(90deg);

					&.is-active {
						transform: rotate(-90deg);
					}
				}
			}
		}

		.el-form {
			margin-top: 40px;

			:deep(&-item) {
				&__label {
					font-size: 14px;
					color: #666666;
				}

				&.limit_box {
					.el-form-item__label {
						line-height: 18px;
					}
				}
			}

			.el-select {
				width: 290px;
			}

			.el-input {
				width: 290px;
			}
		}

		&-tips {
			margin-top: 40px;
			font-size: 14px;
			line-height: 24px;
			color: #f0413e;
		}
	}

	&-footer {
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;

		.el-button {
			width: 90px;
			height: 35px;
			padding: 0;
			border-radius: 6px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: solid 1px #dddddd;
			color: #333333;
			font-size: 12px;

			&.default {
				background-color: #ffffff;
			}

			&.primary {
				color: #fff;
				background-color: #f0413e;
				border-color: #f0413e;
			}
		}
	}
}
</style>
